var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 17.9997C17.5269 18.4731 16.7594 18.4731 16.286 17.9997L6.00028 7.71401C5.52689 7.24062 5.52689 6.47311 6.00028 5.99972C6.47367 5.52633 7.24118 5.52634 7.71457 5.99972L18.0003 16.2854C18.4737 16.7588 18.4737 17.5263 18.0003 17.9997Z",
    fill: "#3B4C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1002 18.3002C7.60314 18.7973 6.79725 18.7973 6.3002 18.3002C5.80314 17.8031 5.80314 16.9973 6.3002 16.5002L16.5002 6.3002C16.9973 5.80314 17.8031 5.80314 18.3002 6.3002C18.7973 6.79725 18.7973 7.60314 18.3002 8.1002L8.1002 18.3002Z",
    fill: "#3B4C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cac8ca26a23bdfe75f1bc6513fc51871.svg";
export { ForwardRef as ReactComponent };